import { faMemo } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@nazka/nazka.mapframe.components';

function CompanyVacancyList({
  onVacancyClick,
  title,
  vacancies,
}) {
  if (!vacancies.length) {
    return null;
  }

  return (
    <div className="shared-company-info__content__top__meta__other-vacancies">
      <h4 className="shared-company-info__content__top__meta__other-vacancies__title">
        {title}
      </h4>
      <ul className="shared-company-info__content__top__meta__other-vacancies__list">
        {vacancies.map((v) => {
          return (
            <li
              className="shared-company-info__content__top__meta__other-vacancies__list__item"
              key={v.properties.vacatureReferentie.vdabReferentie}
            >
              <Button
                layout="ghost"
                icon={faMemo}
                hover={false}
                className="shared-company-info__content__top__meta__other-vacancies__list__item__button"
                onClick={() => {
                  onVacancyClick(v);

                  window.gtag?.('event', 'vacancy_click_another_job_at_same_employer_button', {
                    event_category: 'Vacancy',
                    event_label: 'Vacancy click an another job at same employer button',
                    vdabReferentie: v.properties?.vacatureReferentie?.vdabReferentie,
                  });
                }}
              >
                {v?.properties?.functie?.functieTitel}
              </Button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default CompanyVacancyList;